import { Injectable } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ClientStatus } from "src/app/enum";
import { ClientsListViewType } from "../enum/ClientsListViewType";

@Injectable({ providedIn: "root" })
export class ClientsListState {
  public isFullScreen = false;
  public zoom = 1;

  public listViewType: ClientsListViewType = ClientsListViewType.All; // LocalStorage.getValue(LOCAL_STORAGE_KEY.CLIENTS_LIST_VIEW_TYPE) ||
  public status = ClientStatus.Active;

  public isSearchLoading = false;
  public searchData = new FormGroup({
    searchTerm: new FormControl(),
    clientTags: new FormControl()
  });

  public controls = new FormGroup({
    statusFilter: new FormControl(this.status),
    listFilterType: new FormControl(this.listViewType)
  });

  public FILTER_ACTIVE = `status eq '${ClientStatus.Active}'`;
  public FILTER_DISABLED = `status eq '${ClientStatus.Disabled}'`;

  // public FILTER_ALL = `status eq '${ClientStatus.Active}' or status eq '${ClientStatus.Disabled}'`;
  public FILTER_RETAILERS = `isRetailer eq true`;
  public FILTER_CLIENTS = `isMyClient eq true`;
  public FILTER_PARTNERS = `clientType has 'partner'`;

  public listFilter = this.getListFilter(this.status, this.listViewType);

  public getTypeFilter(viewType: ClientsListViewType) {
    switch (viewType) {
      case ClientsListViewType.Retailers:
        return this.FILTER_RETAILERS;
      case ClientsListViewType.Owned:
        return this.FILTER_CLIENTS;
      case ClientsListViewType.Partners:
        return this.FILTER_PARTNERS;
      default:
        return "";
    }
  }

  public getStatusFilter(status: ClientStatus) {
    switch (status) {
      case ClientStatus.Active:
        return this.FILTER_ACTIVE;
      case ClientStatus.Disabled:
        return this.FILTER_DISABLED;
    }
  }

  public getListFilter(status: ClientStatus, viewType: ClientsListViewType) {
    const statusFilter = this.getStatusFilter(status);
    const typeFilter = this.getTypeFilter(viewType);

    if (!typeFilter) {
      return statusFilter;
    }

    return `${statusFilter} and ${typeFilter}`;
  }

  public setListFilter(status: ClientStatus, viewType: ClientsListViewType) {
    this.listFilter = this.getListFilter(status, viewType);
  }

  public setListView(status: ClientStatus, viewType: ClientsListViewType) {
    this.status = status;
    this.listViewType = viewType;
    this.listFilter = this.getListFilter(status, viewType);
    this.controls.patchValue({
      statusFilter: status,
      listFilterType: viewType
    }, { emitEvent: false });
  }

  public serializeSearchData() {
    const searchData = this.searchData.value;
    return {
      searchTerm: searchData.searchTerm,
      clientTagIds: searchData.clientTags?.map((x: any) => x.id)
    };
  }
}
